angular
  .module('contrast.services.password', [])
  .factory('PasswordService', function (GlobalService) {
    'ngInject'

    return {
      buildPolicy: function (policy) {
        var viewPolicy = {}
        viewPolicy.minLength = policy.min_length
        viewPolicy.minLower = policy.min_lower
        viewPolicy.minNumber = policy.min_numbers
        viewPolicy.minSymbols = policy.min_symbols
        viewPolicy.minUpper = policy.min_upper
        viewPolicy.lockUnusedAccounts = policy.lock_unused_accounts
        viewPolicy.checkMinimumDiffCharacters =
          '' + policy.password_check_diff_chars
        viewPolicy.checkMinimumChangeTime =
          '' + policy.password_check_min_change_time
        viewPolicy.passwordExpirationDays = policy.password_expiration_days
        viewPolicy.passwordHistory = '' + policy.password_history
        viewPolicy.minimumChangeTime = policy.password_min_change_time
        viewPolicy.minimumDiffCharacters = policy.password_min_diff_chars
        viewPolicy.passwordsRetained = policy.passwords_retained
        if (policy.passwords_failed_attempts) {
          viewPolicy.overrideFailed = true
          viewPolicy.failedAttempts = policy.passwords_failed_attempts
        } else {
          viewPolicy.overrideFailed = false
          viewPolicy.failedAttempts = GlobalService.getMaxFailedAttempts()
        }

        return viewPolicy
      },
      convertToPasswordPolicy: function (policy) {
        var data = {}
        data.min_length = policy.minLength
        data.min_lower = policy.minLower
        data.min_numbers = policy.minNumber
        data.min_symbols = policy.minSymbols
        data.min_upper = policy.minUpper
        data.lock_unused_accounts = policy.lockUnusedAccounts
        data.password_expiration_days = policy.passwordExpirationDays
        data.password_history = policy.passwordHistory
        data.passwords_retained = policy.passwordsRetained
        data.password_check_min_change_time = policy.checkMinimumChangeTime
        data.password_min_change_time = policy.minimumChangeTime
        data.password_check_diff_chars = policy.checkMinimumDiffCharacters
        data.password_min_diff_chars = policy.minimumDiffCharacters
        if (policy.overrideFailed) {
          data.passwords_failed_attempts = policy.failedAttempts
        } else {
          data.passwords_failed_attempts = undefined
        }
        return data
      }
    }
  })
